<app-top-navbar></app-top-navbar>
<router-outlet></router-outlet>
<app-system-notifications></app-system-notifications>
